import { Component, OnInit } from '@angular/core';
import { AppService } from '../app.service';
import{ Prepaid } from './prepaid';  
import { NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-prepaid',
  templateUrl: './prepaid.component.html',
  styleUrls: ['./prepaid.component.css']
})

export class PrepaidComponent implements OnInit {

  prepaid=new Prepaid;

  constructor(private service:AppService,private config:NgbCarouselConfig) {
    config.interval=2000,
    config.wrap=true,
    config.keyboard=false
  }

  operatorList:[];
  rchprocess:boolean=false;
  errorMsg:any; 
  orderHistory:boolean=false;
  paymentHistory:boolean=false;
  date : Date = new Date(); 

  ngOnInit() { 
    this.getAllOperator();  
  }

  setRechargeType(){
    if(this.prepaid.operator=='BS'){
      this.prepaid.recharge_type='';
    }else if(this.prepaid.operator!=''){
      this.prepaid.recharge_type='0';
    }
  }
  
  getAllOperator() {  
    this.rchprocess=true; 
    this.service.post('/getOperatorList',{type:"prepaid"}).subscribe(data => {
        if(data[0].error=='0')
        {
            this.operatorList=data[0].result;
        }
        this.rchprocess=false;
      },
      error =>{
        alert(error.errorDesc); 
        console.log(error); 
        this.rchprocess=false;
      }
    );
  }

  getHistory(){
      this.orderHistory=true;
  }

  rechargeBack(){
    this.orderHistory=false;
  }

  doRecharge(){
    var chkLogin=this.service.isLoggedIn();

    if(chkLogin){
      var ddd=confirm("Are you want to confirm this recharge.");

      if(ddd){ 
        this.rchprocess=true; 
        this.errorMsg='';
        var data={key:this.service.getAuthorizationToken(),mobile_no:this.prepaid.mobile,service_provider:this.prepaid.operator,recharge_type:this.prepaid.recharge_type,amount:this.prepaid.amount,referance_no:0};
        this.service.post('/doRecharge',data).subscribe(data => {
            if(data[0].error=='0')
            {
              console.log(data[0].msg);
              this.paymentHistory=true;
              this.orderHistory=false;
        }else{
              console.log(data[0].msg);
            }
            alert(data[0].msg);
            this.rchprocess=false; 
          },
          error =>{
            alert(error.errorDesc); 
            console.log(error); 
            this.rchprocess=false; 
          }
        );  
      }
    }
    else{
      alert("Please first login.");
    }
  } 
  
  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
}
